import {
  Badge,
  Chip,
  IconButton,
  LinearProgress,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import React from "react";
import Iconify from "src/components/iconify";
import MultiUploadBox from "./MultiUploadBox";
import AudioBox from "./AudioBox";
import cogoToast from "cogo-toast";
import { WithAPICall } from "../utils/apiUtil";
import AILoader from "../utils/AILoader";
import { nanoid } from "nanoid";
import { diffChars } from "diff";
import "./InputBox.css";

class InputBox extends React.Component {
  state = {
    text: "",
    openUploader: false,
    uploadedFiles: [],
    isAudio: false,
    isAddingMessage: false,
    isSharing: false,
    polishedText: "",
    diffData: [],
  };
  calculateDiff() {
    const { text, polishedText, diffData } = this.state;
    let offset = 0;
    const diff = diffChars(
      text.substring(offset, offset + polishedText.length),
      polishedText
    );
    offset += polishedText.length;
    const augmentedDiff = diff.map((part, index) => ({
      ...part,
      flash: !diffData[index] || part.value !== diffData[index]?.value,
    }));
    const remainingTranscribedText = text.substring(offset);
    if (remainingTranscribedText) {
      augmentedDiff.push({
        value: remainingTranscribedText,
        added: false,
        removed: false,
        flash: false,
      });
    }
    this.setState({ diffData: augmentedDiff });
  }
  polishText = async () => {
    this.setState({
      isAddingMessage: true,
    });
    let originalText = this.state.text;

    let payload = {
      text: originalText,
    };
    let URL = "/harley/polishCase";
    try {
      await this.props.apiCallPostStreamingForAI(
        URL,
        payload,
        (data) => {
          this.setState(
            {
              polishedText: this.state.polishedText + data,
            },
            () => {
              this.calculateDiff();
            }
          );
        },
        () => {
          this.onPolishingEnd();
        }
      );
    } catch (err) {
      cogoToast.error("Error polishing text, proceeding with original text");
      this.addMessage();
      return;
    }
  };
  onPolishingEnd = async () => {
    // wait 1 second
    await new Promise((r) => setTimeout(r, 1000));
    this.setState(
      {
        text: this.state.polishedText,
      },
      () => {
        this.addMessage();
      }
    );
  };
  addMessage = async () => {
    let fileIds = [];
    if (this.state.uploadedFiles.length) {
      fileIds = this.state.uploadedFiles.map((f) => f._id);
    }
    this.setState({
      isAddingMessage: true,
    });
    try {
      let tt = this.state.text;

      let payload = {
        threadId: this.props.threadId,
        content: tt,
        fileIds: fileIds,
      };
      let nn = null;

      if (this.props.isCaseNote) {
        nn = nanoid();
        payload = {
          caseId: this.props.caseId,
          content: tt,
          nanoid: nn,
        };
      }
      let URL = "/harley/addMessageToThread";
      if (this.props.isCaseNote) {
        URL = "/harley/addMessageToCase";
      }
      let res = await this.props.apiCallPost(URL, payload);
      this.setState(
        {
          text: "",
          uploadedFiles: [],
          isAddingMessage: false,
          polishedText: "",
          diffData: [],
        },
        () => {
          if (this.props.isCaseNote) {
            this.props.onAddMessage(res, nn);
          } else {
            this.props.onAddMessage(res);
          }
        }
      );
    } catch (err) {
      console.log(err);
      this.setState({ isAddingMessage: false });
      cogoToast.error("Error sending message");
    }
  };
  renderTextArea = () => {
    if (this.props.disabled) {
      return (
        <Paper
          sx={{
            padding: 2,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            bgcolor: "background.neutral",
          }}
        >
          <Stack spacing={2}>
            <Typography variant="overline">Harley</Typography>
            <AILoader />
            <LinearProgress />
          </Stack>
        </Paper>
      );
    }
    if (this.state.isAudio) {
      return (
        <Paper
          sx={{
            padding: 2,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            bgcolor: "background.neutral",
          }}
        >
          <AudioBox
            threadId={
              this.props.isCaseNote ? this.props.caseId : this.props.threadId
            }
            onError={() => {
              this.setState({ isAudio: false });
            }}
            onTranscription={(transcription) => {
              this.setState({ text: transcription, isAudio: false }, () => {
                if (this.props.isCaseNote) {
                  this.polishText();
                } else {
                  this.addMessage();
                }
              });
            }}
          />
        </Paper>
      );
    }
    return (
      <TextField
        InputLabelProps={{
          shrink: this.state.text,
        }}
        disabled={this.state.isAddingMessage || this.props.disabled}
        fullWidth
        multiline
        minRows={4}
        label="Your Message"
        value={this.state.text}
        onChange={(e) => {
          this.setState({ text: e.target.value });
        }}
      />
    );
  };
  renderUploadButton = () => {
    if (this.props.isCaseNote) {
      return null;
    }
    if (this.state.isAudio) {
      return null;
    }
    if (this.state.uploadedFiles.length) {
      return (
        <Box>
          <Badge badgeContent={this.state.uploadedFiles.length}>
            <IconButton
              disabled={this.state.isAddingMessage || this.props.disabled}
              onClick={() => {
                this.setState({
                  openUploader: !this.state.openUploader,
                });
              }}
            >
              <Iconify icon={"teenyicons:attach-solid"} />
            </IconButton>
          </Badge>
        </Box>
      );
    }
    return (
      <Box>
        <IconButton
          onClick={() => {
            this.setState({
              openUploader: !this.state.openUploader,
            });
          }}
        >
          <Iconify icon={"teenyicons:attach-solid"} />
        </IconButton>
      </Box>
    );
  };
  renderAudioButton = () => {
    return (
      <Box>
        <IconButton
          disabled={this.state.isAddingMessage || this.props.disabled}
          onClick={() => {
            this.setState({
              isAudio: !this.state.isAudio,
            });
          }}
        >
          <Iconify
            icon={!this.state.isAudio ? "bi:mic-fill" : "gridicons:cross"}
          />
        </IconButton>
      </Box>
    );
  };
  renderSendButton = () => {
    if (this.state.isAudio) {
      return null;
    }
    if (this.props.disabled) {
      return (
        <Box>
          <IconButton
            sx={{
              bgcolor: "primary.main",
              color: "primary.contrastText",
              "&:hover": {
                bgcolor: "primary.dark",
              },
            }}
          >
            <Iconify icon={"svg-spinners:blocks-wave"} />
          </IconButton>
        </Box>
      );
    }
    if (this.state.isAddingMessage) {
      return (
        <Box>
          <IconButton
            disabled
            sx={{
              bgcolor: "primary.main",
              color: "primary.contrastText",
              "&:hover": {
                bgcolor: "primary.dark",
              },
            }}
          >
            <Iconify icon={"svg-spinners:blocks-wave"} />
          </IconButton>
        </Box>
      );
    }
    return (
      <Box>
        <IconButton
          sx={{
            bgcolor: "primary.main",
            color: "primary.contrastText",
            "&:hover": {
              bgcolor: "primary.dark",
            },
          }}
          disabled={!this.state.text || this.props.disabled}
          onClick={() => {
            if (this.props.isCaseNote) {
              this.polishText();
            } else {
              this.addMessage();
            }
          }}
        >
          <Iconify icon={"guidance:send"} />
        </IconButton>
      </Box>
    );
  };
  renderButtons = () => {
    if (this.props.disabled) {
      return (
        <Stack>
          <Iconify icon={"svg-spinners:blocks-wave"} />
        </Stack>
      );
    }
    return (
      <Stack>
        {this.renderUploadButton()}
        {this.renderAudioButton()}
        {this.renderSendButton()}
      </Stack>
    );
  };
  renderPolishedText = () => {
    if (this.state.polishedText) {
      return (
        <Stack spacing={1}>
          <Box>
            <Chip
              label="Polished Text"
              size="small"
              color="warning"
              variant="filled"
            />
          </Box>
          <Stack
            direction="row"
            spacing={0.2}
            alignItems={"center"}
            flexWrap={"wrap"}
          >
            {this.state.diffData.map((part, index) => {
              let className = "";
              let color = "secondary.lighter";
              if (part.removed) {
                color = "error.dark";
                className = " strike_through";
              }
              if (part.added) {
                color = "success.dark";
              }
              if (part.flash) {
                color = "info.dark";
                className = " flash";
              }
              return (
                <Typography
                  sx={{
                    bgcolor: color,
                    color: "white",
                    fontWeight: "bold",
                  }}
                  key={index}
                  className={className}
                  variant="subtitle2"
                >
                  {part.value}
                </Typography>
              );
            })}
          </Stack>
        </Stack>
      );
    }
    return null;
  };
  render() {
    let conversationType = this.props.conversationType;

    let acceptedFileTypes = {
      "image/png": [".png"],
      "image/jpeg": [".jpg", ".jpeg"],
      "image/webp": [".webp"],
    };

    if (conversationType === "assistant") {
      acceptedFileTypes = {
        "text/csv": [".csv"],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          [".docx"],
        "text/markdown": [".md"],
        "application/pdf": [".pdf"],
        "application/vnd.openxmlformats-officedocument.presentationml.presentation":
          [".pptx"],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
          ".xlsx",
        ],
        "application/zip": [".zip"],
        "text/xml": [".xml"],
        "text/plain": [".txt"],
        "application/json": [".json"],
      };
    }
    return (
      <Stack>
        <Stack direction="row" spacing={0.5}>
          {this.renderTextArea()}
          {this.renderButtons()}
          <MultiUploadBox
            open={this.state.openUploader}
            threadId={this.props.threadId}
            onUpload={(files) => {
              this.setState({
                uploadedFiles: [...this.state.uploadedFiles, ...files],
                openUploader: false,
              });
            }}
            onClose={() => {
              this.setState({ openUploader: false });
            }}
            acceptedFileTypes={acceptedFileTypes}
          />
        </Stack>
        {this.renderPolishedText()}
      </Stack>
    );
  }
}

export default WithAPICall(InputBox);
